import { commandCreator } from './commandCreator';
import { OpenArArgs } from './types';

export const openARCommand = commandCreator<OpenArArgs>('OPEN_AR');
